
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import styles from './Activity.module.css'; // CSS Module

const data = [
  { month: 'Jan', active: 75, deactive: 95, rejected: 65 },
  { month: 'Feb', active: 60, deactive: 90, rejected: 50 },
  { month: 'Mar', active: 65, deactive: 85, rejected: 30 },
  { month: 'Apr', active: 70, deactive: 92, rejected: 45 },
  { month: 'May', active: 80, deactive: 97, rejected: 60 },
  { month: 'Jun', active: 78, deactive: 93, rejected: 58 },
  { month: 'Jul', active: 62, deactive: 88, rejected: 35 },
  { month: 'Aug', active: 55, deactive: 84, rejected: 40 },
  { month: 'Sep', active: 50, deactive: 82, rejected: 25 },
  { month: 'Oct', active: 52, deactive: 85, rejected: 28 },
  { month: 'Nov', active: 48, deactive: 80, rejected: 20 },
  { month: 'Dec', active: 55, deactive: 83, rejected: 30 }
];

const Activity = () => {

  return (
    <div className={styles.card} >
      <div className={styles.header}>
        <h2 className={styles.heading}>Call Activity</h2>
        <div className={styles.toggleGroup}>
          <button className={styles.toggleBtn}>Monthly</button>
          <button className={styles.toggleBtn}>Weekly</button>
          <button className={`${styles.toggleBtn} ${styles.active}`}>Daily</button>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={350}>
        <LineChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="month" />
          <YAxis
            domain={[0, 100]}
            ticks={[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
            tickFormatter={(value) => `${value}%`}
          />
          <Tooltip formatter={(value) => `${value}%`} />
          <Line type="monotone" dataKey="active" stroke="#2E71F3" strokeWidth={3} dot={false} name="Total Calls" />
          <Line type="monotone" dataKey="deactive" stroke="green" strokeWidth={2} strokeDasharray="5 5" dot={false} name="Total Joined Calls" />
          <Line type="monotone" dataKey="rejected" stroke="red" strokeWidth={2} dot={false} name="Total Unjoined Calls" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Activity;
